<template>
  <div class="fixed inset-0 bg-gray-100 text-black z-50 flex overflow-y-auto">
    <figure v-if="zoomed.type === 'image'" class="pb-6 pt-14 sm:pt-18 sm:px-4 flex flex-col md:flex-row w-full max-h-full justify-between">
      <figcaption v-html="caption" class="md:w-64 text-xs mt-2 px-4 md:px-0 flex-none mr-8"></figcaption>
      <div :key="zoomed.src" class="mr-2">
        <base-image :img="zoomed" @click.native="nextImg" class="zoom-max cursor-pointer"/>
        <!-- <img :src="smImg(zoomed)" :srcset="blank" :data-sizes="imgSizes(zoomed)" :data-srcset="zoomed.srcset" :key="zoomed.src" @lazybeforeunveil="imgReady" class="lazyload zoom-max cursor-pointer" sizes="auto" @click="nextImg" /> -->
      </div>
    </figure>

    <div v-else-if="zoomed.type === 'video'" class="pb-6 pt-14 sm:pt-18 sm:px-4 flex w-full max-h-full justify-between">
      <div v-html="caption" class="w-64 text-xs mt-2 px-4 md:px-0 flex-none mr-8"></div>
      <div class="mr-2">
        <video :src="zoomed.src" controls />
      </div>
    </div>

    <div v-else-if="zoomed.type === 'audio'" class="pb-6 pt-14 sm:pt-18 sm:px-4 flex w-full max-h-full justify-between">
      <div v-html="caption" class="w-64 text-xs mt-2 px-4 md:px-0 flex-none mr-8"></div>

      <div class="w-full mr-2">
        <div class="p-4 rounded bg-gray-600 w-full">
          <audio :src="zoomed.src" controls class="w-full"></audio>
        </div>
      </div>
    </div>

    <div class="fixed top-0 left-0 w-full bg-gray-100 flex justify-between items-center border-b border-black">
      <div class="mx-6">
        <a @click="prevImg" class="cursor-pointer text-2xl pr-4 hover:text-orange-brand">&larr;</a>
        <a @click="nextImg" class="cursor-pointer text-2xl px-4 hover:text-orange-brand">&rarr;</a>
      </div>
      <div class="flex-auto">{{ currentIdx + 1 }} of {{ imgCount }}</div>
      <div class="mx-6">
        <a @click="close()" class="cursor-pointer text-4xl font-serif hover:text-orange-brand">&times;</a>
      </div>
    </div>
  </div>
</template>

<script>
import { smImg, mdImg, lgImg, imgSizes } from '@/utils'
export default {

  name: 'BaseLightbox',

  props: ['files', 'idx'],

  data () {
    return {
      blank: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
      currentIdx: this.idx,
      changingImg: false
    }
  },

  computed: {
    zoomed () {
      if (typeof this.idx === 'number') {
        return this.files[this.currentIdx]
      }
      return false
    },
    imgCount () {
      return this.files.length
    },
    caption () {
      if (!this.zoomed) return ''
      const c = this.zoomed.content
      return c ? c.caption : ''
    }
  },

  methods: {
    smImg,
    mdImg,
    lgImg,
    imgSizes,

    close () {
      this.$emit('close')
    },
    imgReady () {
      this.$nextTick(() => {
        this.changingImg = false
      })
    },
    imgNav ({ code }) {
      if (code === 'ArrowRight') {
        this.nextImg()
      } else if (code === 'ArrowLeft') {
        this.prevImg()
      } else if (code === 'Escape') {
        this.close()
      }
    },
    nextImg () {
      this.changingImg = true
      this.$nextTick(() => {
        const to = this.currentIdx + 1
        this.currentIdx = to < this.imgCount ? to : 0
      })
    },
    prevImg () {
      this.changingImg = true
      this.$nextTick(() => {
        const to = this.currentIdx - 1
        this.currentIdx = to >= 0 ? to : this.imgCount - 1
      })
    }
  },
  mounted () {
    window.addEventListener('keyup', this.imgNav)
  },
  beforeDestroy () {
    window.removeEventListener('keyup', this.imgNav)
  }
}
</script>
